import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import "./AddBlockerButton.css";
import { addBlockers } from "../../services/wisdomServices/growthService";
import { getSessionItem } from "../../utils/helper/session";

const MAX_TITLE_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 255;

function AddBlockerButton() {
    const projects = getSessionItem("projects")
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [severity, setSeverity] = useState(null);
    const severityOptions = [
        { label: "Low", value: "low" },
        { label: "Medium", value: "medium" },
        { label: "High", value: "high" }
    ];

    const closeModal = () => {
        setVisible(false);
        setSelectedProject(null);
        setTitle("");
        setDescription("");
        setSeverity(null);
    };

    const handleSubmit = async () => {
        if (
            !title.trim() ||
            !description.trim() ||
            !severity ||
            !selectedProject?.managerId
        ) {
            return;
        }

        try {
            setLoading(true);

            await addBlockers({
                title: title.trim(),
                description: description.trim(),
                severity,
                ownerId: selectedProject.managerId
            });

            closeModal();
        } catch (error) {
            console.error("Failed to add blocker:", error);
        } finally {
            setLoading(false);
        }
    };

    const isValid =
        title.trim() &&
        description.trim() &&
        severity &&
        selectedProject?.managerId;

    return (
        <>
            <Button
                type="button"
                icon="pi pi-exclamation-triangle"
                label="Add Blocker"
                outlined
                className="summary-kudos-action-button"
                onClick={() => setVisible(true)}
            />

            <Dialog
                header="Add new blocker"
                visible={visible}
                className="blocker-dialog"
                modal
                draggable={false}
                onHide={closeModal}
            >
                <div className="summary-growth-modal">
                    <div className="summary-growth-field">
                        <label htmlFor="blocker-title">
                            Title <span className="char-counter">({MAX_TITLE_LENGTH - title.length} chars left)</span>
                        </label>

                        <InputText
                            id="blocker-title"
                            value={title}
                            maxLength={100}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter blocker title..."
                        />
                    </div>

                    <div className="summary-growth-modal-row">
                        <div className="summary-growth-field">
                            <label htmlFor="blocker-project">
                                Project
                            </label>

                            <Dropdown
                                id="blocker-project"
                                value={selectedProject}
                                options={projects}
                                optionLabel="name"
                                onChange={(e) => setSelectedProject(e.value)}
                                placeholder="Select project"
                                filter
                                filterBy="name"
                            />
                        </div>

                        <div className="summary-growth-field">
                            <label htmlFor="blocker-severity">
                                Severity
                            </label>

                            <Dropdown
                                id="blocker-severity"
                                value={severity}
                                options={severityOptions}
                                onChange={(e) => setSeverity(e.value)}
                                placeholder="Select severity"
                            />
                        </div>
                    </div>

                    <div className="summary-growth-field">
                        <label htmlFor="blocker-description">
                            Description <span className="char-counter">({MAX_DESCRIPTION_LENGTH - description.length} chars left)</span>
                        </label>

                        <InputTextarea
                            id="blocker-description"
                            value={description}
                            maxLength={255}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={5}
                            autoResize
                            placeholder="Describe the blocker..."
                        />
                    </div>

                    <div className="summary-growth-modal-actions">
                        <Button
                            type="button"
                            label="Cancel"
                            severity="secondary"
                            text
                            onClick={closeModal}
                        />

                        <Button
                            type="button"
                            label="Add blocker"
                            icon="pi pi-check"
                            loading={loading}
                            disabled={!isValid}
                            onClick={handleSubmit}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default AddBlockerButton;